import { Measure } from '@cbsi-cbscom/measure';

import NewRelicAdapter from './adapter/NewRelicAdapter';
import { formatEventName } from './helpers';
const MEASURE_AVERAGE_KEY = 'averages';
class CustomMeasure {
    options;
    adapter = null;
    constructor(options = {}) {
        this.options = options;
        switch (options.adapter) {
            case 'newrelic':
            default:
                this.adapter = new NewRelicAdapter(this);
        }
    }
    get namespace() {
        return this.options.namespace;
    }
    start(eventName) {
        Measure.start(formatEventName(eventName, this.options.namespace));
    }
    end(eventName) {
        Measure.end(formatEventName(eventName, this.options.namespace));
    }
    sendEvent({ eventName, customData, senderInstanceFn }) {
        const report = Measure.report();
        const eventData =
            report?.[MEASURE_AVERAGE_KEY]?.[formatEventName(eventName, this.options.namespace)];
        let payload = { measurement: 0 };
        if (this.adapter) {
            if (senderInstanceFn) {
                this.adapter.setSenderInstance(senderInstanceFn());
            }
            if (eventData) {
                payload = { ...payload, measurement: eventData };
            }
            if (customData) {
                payload = { ...payload, ...{ customData: customData } };
            }
            this.adapter.sendEvent({ eventName, payload: payload });
        }
    }
}
export { CustomMeasure };
